import React from "react";

export default function CustomPopupVideo({
  isOpen,
  onClose,
  children,
  modalStyles = "",
  contentStyles = "",
}) {
  if (!isOpen) return null;

  return (
    <div
      className={`fixed inset-0 bg-black bg-opacity-75 flex justify-center items-center z-50 ${modalStyles}`}
      onClick={onClose}
    >
      <div
        className={`relative bg-black rounded max-w-[80vw] w-full max-h-[90vh] flex flex-col overflow-hidden ${contentStyles}`}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex justify-end p-3 border-b border-gray-700">
          <button
            onClick={onClose}
            className="text-white text-3xl font-bold leading-none"
            aria-label="Close modal"
            style={{ lineHeight: 1 }}
          >
            &times;
          </button>
        </div>
        <div className="flex-grow">{children}</div>
      </div>
    </div>
  );
}
